import gql from "graphql-tag";

const imageFields = `id
alternativeText
url
formats`;

export const GET_FORM_BY_SLUG = gql`
  query GET_CMS_BY_SLUG($countryCode: String!, $slug: String!) {
    forms(where: { countries: { twoLetterCode: $countryCode }, slug: $slug, published: true }) {
      id
      title
      meta{
        id
        seo{
          id
          description
          index
          keywords
          thumbnail{
            ${imageFields}
          }
        }
      }
      content {
        __typename
        ... on ComponentFormJotform {
          id
          url
          title
        }
      }
    }
  }
`;
